// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-icon.centered,.loading-icon>div>div.stage{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}`, "",{"version":3,"sources":["webpack://./components/XLoadingIcon.vue"],"names":[],"mappings":"AACA,mDAEE,iBAAA,CACA,OAAA,CACA,QAAA,CACA,+BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
